// ErrorBoundary.js
import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render shows the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Enhanced logging for React rendering errors
    console.error('=== ERROR BOUNDARY CAUGHT ERROR ===');
    console.error('Error:', error);
    console.error('Error Info:', errorInfo);

    // Check if this is the specific "Objects are not valid as a React child" error
    if (
      error.message &&
      error.message.includes('Objects are not valid as a React child')
    ) {
      console.error('🚨 SPECIFIC ERROR: React rendering error detected!');
      console.error(
        'This error occurs when an object is rendered directly in JSX'
      );
      console.error(
        'Look for objects with {to, from, total} properties being rendered'
      );
      console.error('Error stack:', error.stack);
    }

    // Store error information in state for debugging
    this.setState({
      error: error,
      errorInfo: errorInfo,
    });
  }

  render() {
    if (this.state.hasError) {
      // Enhanced fallback UI with debug information
      return (
        <div
          className="text-center mt-5"
          style={{
            padding: '20px',
            backgroundColor: '#f8f9fa',
            border: '1px solid #dee2e6',
          }}
        >
          <h2>Something went wrong with the vehicle report.</h2>
          <p>
            We're sorry for the inconvenience. Please try refreshing the page.
          </p>
          {process.env.NODE_ENV === 'development' && (
            <details style={{ marginTop: '20px', textAlign: 'left' }}>
              <summary>Debug Information (Development Mode)</summary>
              <pre
                style={{
                  backgroundColor: '#f1f3f4',
                  padding: '10px',
                  overflow: 'auto',
                  fontSize: '12px',
                }}
              >
                {this.state.error && this.state.error.toString()}
                <br />
                {this.state.errorInfo && this.state.errorInfo.componentStack}
              </pre>
            </details>
          )}
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
